import{useEffect as n}from"react";var e=function(e,t,o){n((function(){var n=function(n){n.key===e&&o(n)};return t&&window.addEventListener("keydown",n),function(){window.removeEventListener("keydown",n)}}),[t,o,e])};export{e as default};
